import { render, staticRenderFns } from "./PapelTabela.vue?vue&type=template&id=1c08abab"
import script from "./PapelTabela.vue?vue&type=script&lang=js"
export * from "./PapelTabela.vue?vue&type=script&lang=js"
import style0 from "./PapelTabela.vue?vue&type=style&index=0&id=1c08abab&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports